import { render, staticRenderFns } from "./ScreenshotUpload.vue?vue&type=template&id=485276ac&"
import script from "./ScreenshotUpload.vue?vue&type=script&lang=js&"
export * from "./ScreenshotUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports